import { EnglishArabicDTO } from "bbsf-controls"
export class EmailTemplateTesterModel
{
      TemplateID:number
      LangKey :string
      ToEmail :string
      EmailProviderName:string
      KeyMap: Record<string,string>
      ErrorMessage:string
      IsSuccess:boolean


}